<div *ngIf="visible && description"><sbw-banner [description]="description" [label]="label" [link]="link" [visible]="visible" (bannerClosed)="closed($event)"></sbw-banner></div>
